function sliderTextMedia() {
    document.querySelectorAll('.block_text_media').forEach(function (block) {
        const swiperContainer = block.querySelector('.text_media_swiper-js');
        if (!swiperContainer) return;

        const thumbsList = block.querySelector('.text_media_thumbs');
        const thumbs     = block.querySelectorAll('.text_media_thumb-js');

        // Vignette active + défilement de la rangée (sans faire défiler la page)
        function setActiveThumb(index) {
            thumbs.forEach(function (thumb, i) {
                thumb.classList.toggle('active', i === index);
            });

            const active = thumbs[index];
            if (thumbsList && active) {
                const item = active.parentElement;
                thumbsList.scrollTo({
                    left: item.offsetLeft - (thumbsList.clientWidth - item.clientWidth) / 2,
                    behavior: 'smooth',
                });
            }
        }

        const swiper = new Swiper(swiperContainer, {
            loop: swiperContainer.querySelectorAll('.swiper-slide').length > 1,
            slidesPerView: 1,
            spaceBetween: 0,
            navigation: {
                nextEl: block.querySelector('.text_media_next-js'),
                prevEl: block.querySelector('.text_media_prev-js'),
            },
            on: {
                slideChange: function (s) {
                    setActiveThumb(s.realIndex);
                },
            },
        });

        thumbs.forEach(function (thumb) {
            thumb.addEventListener('click', function () {
                swiper.slideToLoop(parseInt(thumb.dataset.index, 10));
            });
        });
    });
}

document.addEventListener('DOMContentLoaded', sliderTextMedia);
